// src/utils/errorMessages.js
/**
 * Generic error messages for user-facing errors
 * ไม่เปิดเผย technical details
 */

export const ERROR_MESSAGES = {
  // Authentication errors
  LOGIN_FAILED: "Username or password is incorrect. Please try again.",
  LOGIN_ERROR: "Unable to log in. Please try again later.",
  UNAUTHORIZED: "Your session has expired. Please log in again.",
  FORBIDDEN: "You don't have permission to access this resource.",
  
  // Network errors
  NETWORK_ERROR: "Unable to connect to the server. Please check your internet connection and try again.",
  TIMEOUT_ERROR: "The request took too long. Please try again.",
  SERVER_ERROR: "The server encountered an error. Please try again later.",
  
  // Validation errors
  INVALID_EMAIL: "Please enter a valid email address.",
  INVALID_PHONE: "Please enter a valid phone number.",
  REQUIRED_FIELD: "Please fill in all required fields.",
  PASSWORD_MISMATCH: "Passwords do not match. Please try again.",
  WEAK_PASSWORD: "Password must be at least 8 characters long.",
  
  // Form submission errors
  SUBMIT_ERROR: "Unable to submit the form. Please try again.",
  SAVE_ERROR: "Unable to save changes. Please try again.",
  LOAD_ERROR: "Unable to load data. Please refresh the page.",
  
  // Generic errors
  UNKNOWN_ERROR: "An unexpected error occurred. Please try again.",
  NOT_FOUND: "The requested resource was not found.",
  
  // License errors
  LICENSE_NOT_FOUND: "License not found. Please check your license key.",
  LICENSE_EXPIRED: "This license has expired.",
  LICENSE_INVALID: "Invalid license key.",
};

/**
 * Get user-friendly error message
 * @param {Error|string|Response} error - Error object, message string, or Response
 * @param {string} context - Context of the error (e.g., "login", "submit")
 * @returns {string} User-friendly error message
 */
export function getUserFriendlyError(error, context = "general") {
  // If it's a Response object, check status
  if (error && typeof error.status === "number") {
    if (error.status === 401) return ERROR_MESSAGES.UNAUTHORIZED;
    if (error.status === 403) return ERROR_MESSAGES.FORBIDDEN;
    if (error.status === 404) return ERROR_MESSAGES.NOT_FOUND;
    if (error.status >= 500) return ERROR_MESSAGES.SERVER_ERROR;
    if (error.status >= 400) return ERROR_MESSAGES.SUBMIT_ERROR;
  }
  
  // If it's an Error object or string
  const errorMessage = typeof error === "string" 
    ? error 
    : error?.message || "";
  
  // Map common error messages to user-friendly ones
  const lowerMessage = errorMessage.toLowerCase();
  
  if (lowerMessage.includes("network") || lowerMessage.includes("fetch")) {
    return ERROR_MESSAGES.NETWORK_ERROR;
  }
  
  if (lowerMessage.includes("timeout")) {
    return ERROR_MESSAGES.TIMEOUT_ERROR;
  }
  
  if (lowerMessage.includes("unauthorized") || lowerMessage.includes("401")) {
    return ERROR_MESSAGES.UNAUTHORIZED;
  }
  
  if (lowerMessage.includes("forbidden") || lowerMessage.includes("403")) {
    return ERROR_MESSAGES.FORBIDDEN;
  }
  
  if (lowerMessage.includes("not found") || lowerMessage.includes("404")) {
    return ERROR_MESSAGES.NOT_FOUND;
  }
  
  if (context === "login") {
    if (lowerMessage.includes("password") || lowerMessage.includes("username") || lowerMessage.includes("incorrect")) {
      return ERROR_MESSAGES.LOGIN_FAILED;
    }
    return ERROR_MESSAGES.LOGIN_ERROR;
  }
  
  if (context === "email") {
    return ERROR_MESSAGES.INVALID_EMAIL;
  }
  
  if (context === "phone") {
    return ERROR_MESSAGES.INVALID_PHONE;
  }
  
  // Default to generic error
  return ERROR_MESSAGES.UNKNOWN_ERROR;
}
